import { Calculator } from '@dynameat/views/reporting/models/calculator';
import { OCCUPATION } from '../../constants';
import { OccupationQuery } from '../queries';

export class OccupationCalculator extends Calculator {
  kpiType = OCCUPATION

  async calculateKPI() {
    const currentResponse = await this.executeUncubeQuery(OccupationQuery, this.currentPeriod);
    let props;
    if (this.previousPeriod) {
      const previousResponse = await this.executeUncubeQuery(OccupationQuery, this.previousPeriod);
      props = this.getData(currentResponse.data.result[0][0], previousResponse.data.result[0][0]);
    } else props = this.getDataIfNoPreviousPeriod(currentResponse.data.result[0][0]);
    return this.getModelToInstance(props);
  }
}
